import React from 'react';
import { graphql } from 'gatsby';

import SEO from '../components/seo';
import { Typography, Container, Box } from '@material-ui/core';
import { AboutPageQuery } from '../../types/graphql-types';
import CardImage from '../components/image/card-image';
import RichContent from '../components/text/rich-content';

export interface AboutPageProps {
  data: AboutPageQuery;
}

const AboutPage = ({ data }: AboutPageProps): JSX.Element => {
  const { contentfulAboutUs } = data;

  const image = contentfulAboutUs?.heroImage?.gatsbyImageData?.images?.fallback?.src;

  return (
    <>
      <SEO title={contentfulAboutUs?.title || ''} />
      <Box mb={5} mt={5}>
        <Container>
          <Typography component="h1" variant="h3" align="left" color="textPrimary" gutterBottom>
            {contentfulAboutUs?.title}
          </Typography>
          <Typography variant="h5" color="textSecondary" paragraph>
            {contentfulAboutUs?.preamble}
          </Typography>
          <CardImage image={image} title="Image title" />
          <RichContent
            dangerouslySetInnerHTML={{
              __html: contentfulAboutUs?.body?.childMarkdownRemark?.html || '',
            }}
          />
        </Container>
      </Box>
    </>
  );
};

export default AboutPage;

export const pageQuery = graphql`
  query AboutPage {
    contentfulAboutUs {
      title
      preamble
      heroImage {
        gatsbyImageData(width: 1232, height: 1080, quality: 90)
      }
      body {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`;
